/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Make_MemberInputs */

const en_us2_clubs_make_member = /** @type {(inputs: Clubs_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove admin`)
};

const pt_br2_clubs_make_member = /** @type {(inputs: Clubs_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar de admin`)
};

const es_419_clubs_make_member = /** @type {(inputs: Clubs_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar admin`)
};

const pt_pt2_clubs_make_member = /** @type {(inputs: Clubs_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar admin`)
};

const fr_fr2_clubs_make_member = /** @type {(inputs: Clubs_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer l'admin`)
};

const de_de2_clubs_make_member = /** @type {(inputs: Clubs_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin entziehen`)
};

const it_it2_clubs_make_member = /** @type {(inputs: Clubs_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Togli admin`)
};

/**
* | output |
* | --- |
* | "Remove admin" |
*
* @param {Clubs_Make_MemberInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_make_member = /** @type {((inputs?: Clubs_Make_MemberInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Make_MemberInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_make_member(inputs)
	if (locale === "es-419") return es_419_clubs_make_member(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_make_member(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_make_member(inputs)
	if (locale === "de-DE") return de_de2_clubs_make_member(inputs)
	if (locale === "it-IT") return it_it2_clubs_make_member(inputs)
	return en_us2_clubs_make_member(inputs)
});
export { clubs_make_member as "clubs.make_member" }